'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _screenService = require('./screenService');

Object.defineProperty(exports, 'screenService', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_screenService).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/services/index.js
// module id = 665
// module chunks = 0